export default __webpack_public_path__ + "static/media/processes.04f7cb1a.jpg";